<template>
    <header
        id="header"
        class="navbar navbar-expand-lg navbar-fixed navbar-height navbar-flush navbar-container navbar-bordered"
    >
        <div class="navbar-nav-wrap">
            <div class="navbar-brand-wrapper d-flex align-items-center">
                <!-- Navbar Vertical Toggle -->
                <button
                    type="button"
                    class="js-navbar-vertical-aside-toggle-invoker navbar-vertical-aside-toggle btn btn-icon btn-xs btn-ghost-dark mr-2"
                >
                    <i class="tio-menu-hamburger tio-lg"></i>
                </button>
                <!-- End Navbar Vertical Toggle -->

                <!-- Logo -->
                <a
                    class="navbar-brand ml-1 mr-3"
                    href="/"
                    aria-label="Front"
                >
                    <img
                        class="navbar-brand-logo"
                        src="/images/cashouse_logo.png"
                        alt="Logo"
                    />
                    <!-- <img
                        class="navbar-brand-logo-mini"
                        src="/images/cashouse_logo_mobile_icon.png"
                        alt="Logo"
                    /> -->
                </a>
                <span class="font-weight-bold">{{ sectionTitle }}</span>
                <!-- End Logo -->

                <!-- <div class="navbar-nav-wrap-content-left">
                    <button
                        type="button"
                        class="js-navbar-vertical-aside-toggle-invoker close mr-3 d-block d-lg-none"
                    >
                        <i
                            class="tio-first-page navbar-vertical-aside-toggle-short-align"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Collapse"
                        ></i>
                        <i
                            class="tio-last-page navbar-vertical-aside-toggle-full-align"
                            data-template='<div class="tooltip d-none d-sm-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Expand"
                        ></i>
                    </button>
                </div> -->
            </div>

            <!-- Secondary Content -->
            <div class="navbar-nav-wrap-content-right">
                <!-- Navbar -->
                <ul class="navbar-nav align-items-center flex-row">
                    <li class="nav-item">
                        <!-- Account -->
                        <div class="hs-unfold">
                            <a
                                ref="invoker"
                                class="js-hs-unfold-invoker navbar-dropdown-account-wrapper"
                                href="javascript:;"
                                data-hs-unfold-options='{"target": "#accountNavbarDropdown", "type": "css-animation"}'
                            >
                                <span
                                    class="avatar avatar-sm avatar-primary avatar-circle d-flex align-items-center justify-content-center"
                                >
                                    <i class="tio-account-circle"></i>
                                </span>
                            </a>

                            <div
                                id="accountNavbarDropdown"
                                class="hs-unfold-content dropdown-unfold dropdown-menu dropdown-menu-right navbar-dropdown-menu navbar-dropdown-account"
                            >
                                <form
                                    class="dropdown-item"
                                    @submit.prevent="logout"
                                >
                                    <button
                                        type="submit"
                                        class="btn btn-link p-0"
                                    >
                                        <span
                                            class="text-truncate pr-2"
                                            title="Sign out"
                                            >Logout</span
                                        >
                                    </button>
                                </form>
                            </div>
                        </div>
                        <!-- End Account -->
                    </li>
                </ul>
                <!-- End Navbar -->
            </div>
            <!-- End Secondary Content -->
        </div>
    </header>
</template>

<script>
export default {
    props: ["sectionTitle"],
    mounted() {
        var unfold = new HSUnfold($(this.$refs.invoker)).init();
    },

    methods: {
        logout() {
            this.$inertia.post(route("logout"));
        }
    }
};
</script>
